import React from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import { Elements } from '@stripe/react-stripe-js';
// import CheckoutForm from './CheckoutForm';
// import useStripeKey from 'app/hooks/load-stripe-target';

function StripeForm({ ...props }) {
  // const REACT_APP_STRIPE_PUBLISHABLE_KEY = useStripeKey()
  // if (REACT_APP_STRIPE_PUBLISHABLE_KEY) {
  //   const stripePromise = loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY);
  //   return (
  //     <Elements stripe={stripePromise}>
  //       <CheckoutForm
  //         id={props?.calculatedPricing?.productPricing?.id || props?.selectedPlan?.id}
  //         {...props}
  //       />
  //     </Elements>
  //   );
  // }

  return null
}

export default StripeForm;
